import React from 'react';
import { useTranslation } from 'react-i18next';
import { Delete, Edit, Restore } from '@mui/icons-material';
import { toast } from "react-toastify";
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { PRIVATE_USER_FORM_CONTACT_DELEGATION_SERVICE, PRIVATE_USER_FORM_CONTRACT_DELEGATION_SERVICE, PRIVATE_USER_LIST_DELEGATION_SERVICE, PRIVATE_USER_SERVICIOS_CONTRATADOS } from '../../../Constants/PathsConstants';
import { deleteServiceContractDelegationService } from '../../../../Domain/Services/ServiceContractDelegation/DeleteServiceContractDelegationService';
import { getServiceContractDelegationListService } from '../../../../Domain/Services/ServiceContractDelegation/GetServiceContractDelegationListService';
import { patchServiceContractDelegationService } from '../../../../Domain/Services/ServiceContractDelegation/PatchServiceContractDelegationService';
import Loader from 'UI/Application/Components/Loaders/Loader';
import DialogLoader from 'UI/Application/Components/Loaders/DialogLoader';
import { Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Paper, TextField, Grid, Typography, Pagination, DialogTitle, DialogActions, Dialog, DialogContent, Tooltip, IconButton } from '@mui/material';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import AddIcon from "@mui/icons-material/Add";
import { ClearIcon, DatePicker, } from '@mui/x-date-pickers';
import ContactPageIcon from '@mui/icons-material/ContactPage';

import { getContactsFromContractDelegationService } from 'DelegationService/DelegationService/Domain/Services/ServiceContactDelegation/GetContactsFromContractDelegationService';
import { deleteServiceContactDelegationService } from 'DelegationService/DelegationService/Domain/Services/ServiceContactDelegation/DeleteServiceContactDelegationService';
import { getDelegationList } from 'Delegation/Domain/Services/GetDelegationListService';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';
import { GESTOR_DELEGACIONES_SERVICIOS, DELEGADO_DELEGACIONES_SERVICIOS } from 'Shared/Security/Application/Constants/PermissionsConstant';


function TableServiceContractDelegationView() {
    const { t } = useTranslation();
    const [sendingApiRequest, setSendingApiRequest] = React.useState(false);
    const [offset, setOffset] = React.useState(0);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [lastPage, setLastPage] = React.useState(1);
    const [ServiceContractDelegation, setServiceContractDelegation] = React.useState([]);
    const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
    const [loadServiceContractDelegation, setLoadServiceContractDelegation] = React.useState(true);
    const [openContactDeleteModal, setOpenContactDeleteModal] = React.useState(false);
    const [openContactModal, setOpenContactModal] = React.useState(false);
    const [openRestoreModal, setOpenRestoreModal] = React.useState(false);
    const [selectedId, setSelectedId] = React.useState(null);
    const [filterDeleted, setFilterDeleted] = React.useState(0);
    const [id, setId] = React.useState(null);
    const [filterDelegationName, setFilterDelegationName] = React.useState([]);
    const [filterServiceCompanyName, setFilterServiceCompanyName] = React.useState('');
    const [filterDate, setFilterDate] = React.useState(null);
    const limit = 10;
    const [filterUnionDelegationServiceName, setFilterUnionDelegationServiceName] = React.useState('');
    const [filterServiceContractDelegationName, setFilterServiceContractDelegationName] = React.useState('');
    const [contacts, setContacts] = React.useState([]);
    const [loadingContacts, setLoadingContacts] = React.useState(false);
    const [delegacion, setDelegacion] = React.useState([]);
    const [filterExecutionDate, setFilterExecutionDate] = React.useState(0);

    const navigate = useNavigate();
    const { checkPermission } = useAuthContext();
    const [hasAdminPermission, setHasAdminPermission] = React.useState(false);
    const [hasDelegadoPermission, setHasDelegadoPermission] = React.useState(false);
    console.log(hasAdminPermission, hasDelegadoPermission);
    React.useEffect(() => {
        const admin = checkPermission(GESTOR_DELEGACIONES_SERVICIOS);
        const delegado = checkPermission(DELEGADO_DELEGACIONES_SERVICIOS);
        setHasAdminPermission(admin);
        setHasDelegadoPermission(delegado);
        if (!admin && !delegado) {
            navigate(PRIVATE_USER_LIST_DELEGATION_SERVICE, { replace: true });
        }
    }, [checkPermission, navigate]);
    const handleDelete = (id) => { setSelectedId(id); setOpenDeleteModal(true) };
    const handleContactDelete = (id) => { console.log(id); setSelectedId(id); setOpenContactDeleteModal(true) };
    const handleConfirmDelete = () => {
        if (selectedId && !sendingApiRequest) {
            setSendingApiRequest(true);
            deleteServiceContractDelegationService(selectedId).then(response => {
                if (response) {
                    setOpenDeleteModal(false);
                    setLoadServiceContractDelegation(true);
                    setSelectedId(null);
                    toast.success(t("serviceContractDelegation.table.modal.delete.done"));
                }
            }).catch((error) => {
                console.error("Error en el delete", error);
                toast.error(t("serviceContractDelegation.table.modal.delete.error"));
            }).finally(() => { setSendingApiRequest(false) });
        }
    };


    const ShowContact = async (id) => {
        setLoadingContacts(true);
        setContacts([]);
        setId(id);
        console.log(id);
        try {
            const response = await getContactsFromContractDelegationService(id);
            if (response) {
                setContacts(response.records);
                console.log("✅ Datos de contactos:", response);
            }
        } catch (error) { console.error("Error fetching contacts:", error) } finally { setLoadingContacts(false) }
    };
    React.useEffect(() => {
        getDelegationList()
            .then((response) => {
                if (response && response.records) { setDelegacion(response.records) }
            })
            .catch((error) => {
                console.error('Error al cargar delegaciones:', error);
            });
    }, []);

    const handleShowContact = (id) => { setSelectedId(id); setOpenContactModal(true); ShowContact(id) };
    const handleConfirmContactDelete = () => {
        if (selectedId && !sendingApiRequest) {
            setSendingApiRequest(true);
            console.log(selectedId);
            deleteServiceContactDelegationService(selectedId).then(response => {
                console.log(response);
                if (response) {
                    setOpenContactDeleteModal(false);
                    toast.success(t("serviceContactDelegation.table.modal.delete.done"));
                    setContacts(prevContacts => prevContacts.filter(c => c.id !== selectedId));
                }
            }).catch((error) => {
                console.error("Error en el delete", error);
                toast.error(t("serviceContactDelegation.table.modal.delete.error"));
            }).finally(() => {
                setSendingApiRequest(false);

            });
        }
    };
    const handleRestore = (id) => { setSelectedId(id); setOpenRestoreModal(true) };
    const handleRestoreConfirm = () => {
        if (selectedId && !sendingApiRequest) {
            setSendingApiRequest(true);
            const serviceContractDelegationToRestore = ServiceContractDelegation.find(a => a.id === selectedId);
            if (!serviceContractDelegationToRestore) {
                toast.error(t("serviceContractDelegation.restore.error"));
                setSendingApiRequest(false);
                return;
            }
            patchServiceContractDelegationService(selectedId, {
                restore: true,
                name: serviceContractDelegationToRestore.name,
                unionServiceDelegationId: serviceContractDelegationToRestore.unionServiceDelegationId,
                executionDate: serviceContractDelegationToRestore.executionDate,
                startDate: serviceContractDelegationToRestore.startDate,
                endDate: serviceContractDelegationToRestore.endDate,
            }).then((response) => {
                if (response) {
                    setOpenRestoreModal(false);
                    setLoadServiceContractDelegation(true);
                    setSelectedId(null);
                    toast.success(t("serviceContractDelegation.table.modal.restore.done"));
                }
            }).catch((error) => {
                console.error("Error en el patch", error);
                toast.error(t("serviceContractDelegation.restore.error"));
            }).finally(() => { setSendingApiRequest(false) });
        }
    };
    const handleFilterDeletedChange = (event) => {
        setFilterDeleted(event.target.value);
        setLoadServiceContractDelegation(true);
    };
    const handleFilterExecutionDateChange = (event) => {
        setFilterExecutionDate(event.target.value);
        setLoadServiceContractDelegation(true);
    };

    const handleUnionNameFilterChange = (event) => {
        setFilterUnionDelegationServiceName(event.target.value);
        setLoadServiceContractDelegation(true);
    };

    const handleServiceContractDelegationNameFilterChange = (event) => {
        setFilterServiceContractDelegationName(event.target.value);
        setLoadServiceContractDelegation(true);
    };
    const handleDelegationFilterChange = (event) => {

        const { value } = event.target;
        setFilterDelegationName(typeof value === 'string' ? value.split(',') : value);
        console.log(value);
        setLoadServiceContractDelegation(true);
    };
    const handleCompanyFilterChange = (event) => {
        setFilterServiceCompanyName(event.target.value);
        setLoadServiceContractDelegation(true);
    };
    const handleDateChange = (newFilterDate) => {
        if (newFilterDate === null) {
            setFilterDate(null);
        } else {
            setFilterDate(newFilterDate.$d);
        }
        setLoadServiceContractDelegation(true);
    };
    const handlePageChange = (event, newPage) => {
        setCurrentPage(newPage);
        setOffset((newPage - 1) * limit);
        setLoadServiceContractDelegation(true);
    };

    const handleOpenModalCreate = () => { console.log("Abriendo modal con ID: new"); setId("new") };
    React.useEffect(() => {
        if (loadServiceContractDelegation) {
            getServiceContractDelegationListService({
                offset: offset,
                limit: limit,
                filterName: filterServiceContractDelegationName,
                filterUnionServiceDelegationName: filterUnionDelegationServiceName,
                filterDelegationName: filterDelegationName,
                filterServiceCompanyName: filterServiceCompanyName,
                filterExecutionDate: filterExecutionDate,
                filterDate: (filterDate instanceof Date) ? `${filterDate.getFullYear()}-${(filterDate.getMonth() + 1).toString().padStart(2, '0')}-${filterDate.getDate().toString().padStart(2, '0')}` : '',
                filterDeleted: filterDeleted
            }).then((response) => {
                console.log("response from API", response);
                if (!response || !response.records) {
                    setServiceContractDelegation([]);
                    return;
                }
                setServiceContractDelegation(response.records);
                setLastPage(Math.ceil(response.total / limit));
                setLoadServiceContractDelegation(false);
            });
        }
    }, [loadServiceContractDelegation, offset, limit, filterServiceContractDelegationName, filterUnionDelegationServiceName, filterDelegationName, filterServiceCompanyName, filterDeleted, filterExecutionDate]);
    return (
        <>
            <Paper sx={{ margin: 0, padding: 0, display: 'flex', flexDirection: 'column', width: "100%" }}>
                <Box display="flex" alignItems="center" mb={1} paddingTop={1} paddingLeft={1}>
                    <IconButton size="small" onClick={() => navigate(PRIVATE_USER_SERVICIOS_CONTRATADOS)}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="body2" sx={{ ml: 1, cursor: 'pointer' }} onClick={() => navigate(PRIVATE_USER_SERVICIOS_CONTRATADOS)}>Volver</Typography>
                </Box>
                {/* <NavigationBreadcrumbs /> */}
                <Typography variant="h4" sx={{ mb: 2, textAlign: "center" }}>
                    {t('serviceContractDelegation.table.title')}
                </Typography>

                {/* 🔹 Contenedor de filtros */}



                <Box sx={{ p: 2 }}>
                    <Grid container spacing={2} alignItems="flex-end" justifyContent="flex-start">
                        {/* filtro Union Name */}

                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormControl sx={{ width: '250px' }}>
                                <TextField
                                    label={t('unionDelegationService.table.filter_by_name')}
                                    size='small'
                                    variant="outlined"
                                    value={filterUnionDelegationServiceName}
                                    onChange={handleUnionNameFilterChange}
                                />
                            </FormControl>
                        </Grid>
                        {/* filtro Service Contract Delegation Name */}
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormControl sx={{ width: '250px' }}>
                                <TextField
                                    label={t('serviceContractDelegation.table.filter_by_name')}
                                    size='small'
                                    variant="outlined"
                                    value={filterServiceContractDelegationName}
                                    onChange={handleServiceContractDelegationNameFilterChange}
                                />
                            </FormControl>
                        </Grid>
                        {/* filtro Delegaciones*/}
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormControl sx={{ width: '250px' }} size="small">
                                <InputLabel id="delegation-select-label">
                                    {t('serviceContractDelegation.table.filter_by_name3')}
                                </InputLabel>
                                <Select
                                    labelId="delegation-select-label"
                                    multiple
                                    value={filterDelegationName}
                                    onChange={handleDelegationFilterChange}
                                    renderValue={(selected) => (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                            {selected.map((name) => (
                                                <Chip key={name} label={name} size='small' />
                                            ))}
                                        </Box>
                                    )}
                                    label={t('serviceContractDelegation.table.filter_by_name3')}
                                    endAdornment={
                                        filterDelegationName.length > 0 && (
                                            <IconButton
                                                size="small"
                                                sx={{ marginRight: 2 }}
                                                onClick={() => {
                                                    setFilterDelegationName([]);
                                                    setLoadServiceContractDelegation(true);
                                                }} // Limpia el estado
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        )
                                    }
                                >
                                    {[...delegacion]
                                        .sort((a, b) => a.name.localeCompare(b.name)) // Orden alfabético
                                        .map((item) => (
                                            <MenuItem key={item.id} value={item.name}>
                                                {item.name}
                                            </MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* filter Company */}
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormControl sx={{ width: '250px' }}>
                                <TextField
                                    label={t('serviceContractDelegation.table.filter_by_name4')}
                                    size='small'
                                    variant="outlined"
                                    value={filterServiceCompanyName}
                                    onChange={handleCompanyFilterChange}
                                />
                            </FormControl>
                        </Grid>

                        {/* filter Date */}
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormControl sx={{ width: '250px' }}>
                                <DatePicker
                                    label={t('serviceContractDelegation.table.filter_by_name5')}
                                    value={filterDate || null}   // si no hay fecha, null
                                    onChange={(newfilterDate) => handleDateChange(newfilterDate)}
                                    slots={{
                                        textField: (params) => (
                                            <TextField
                                                {...params}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {filterDate && (
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();    // evita abrir el calendario
                                                                        setFilterDate(null);    // limpia
                                                                        handleDateChange(null);
                                                                    }}
                                                                >
                                                                    <ClearIcon fontSize="small" />
                                                                </IconButton>
                                                            )}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    )
                                                }}
                                            />
                                        )
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        {/* filtro Deleted */}

                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormControl sx={{ width: '250px' }} size='small'>
                                <InputLabel id="filter-deleted-label">
                                    {t('serviceContractDelegation.table.filter_by_name_2')}
                                </InputLabel>
                                <Select
                                    labelId='filter-deleted-label'
                                    id='filter-deleted'
                                    label={t('serviceContractDelegation.table.filter_by_name_2')}
                                    value={filterDeleted}
                                    onChange={handleFilterDeletedChange}
                                >
                                    <MenuItem value={0}>{t('serviceContractDelegation.table.filter_by_not_deleted')}</MenuItem>
                                    <MenuItem value={1}>{t('serviceContractDelegation.table.filter_by_deleted')}</MenuItem>
                                    <MenuItem value={2}>{t('serviceContractDelegation.table.filter_deleted_all')}</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormControl sx={{ width: '250px' }} size='small'>
                                <InputLabel id="filter-deleted-label">
                                    {t('serviceContractDelegation.table.filter_by_name_5')}
                                </InputLabel>
                                <Select
                                    labelId='filter-deleted-label'
                                    id='filter-executionDate'
                                    label={t('serviceContractDelegation.table.filter_by_name_5')}
                                    value={filterExecutionDate}
                                    onChange={handleFilterExecutionDateChange}
                                >
                                    <MenuItem value={0}>{t('serviceContractDelegation.table.filter_all')}</MenuItem>
                                    <MenuItem value={1}>{t('serviceContractDelegation.table.filter_pendiente')}</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    {/* Botones */}

                    {/* Boton crear un Contract Delegation */}
                    {hasAdminPermission && (
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, mr: 2 }}>
                            <Button
                                variant="contained"
                                component={RouterLink}
                                to={PRIVATE_USER_FORM_CONTRACT_DELEGATION_SERVICE + "/new"}
                                startIcon={<AddIcon />}
                                sx={{
                                    backgroundColor: "green",
                                    color: "white",
                                    fontWeight: "bold",
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    "&:hover": { backgroundColor: "#008f39" }
                                }}
                                onClick={handleOpenModalCreate}
                            >
                                {t('serviceContractDelegation.form.create')}
                            </Button>
                        </Box>
                    )}


                    {/* Tabla Contract Delegation */}
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: "100%", marginTop: 2 }} arial-label=" service contract delegation table">
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#0492D4' }}>
                                    <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>
                                        {t('serviceContractDelegation.table.delegation')}
                                    </TableCell>
                                    <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>
                                        {t('serviceContractDelegation.table.name')}
                                    </TableCell>
                                    <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>
                                        {t('serviceContractDelegation.table.union')}
                                    </TableCell>
                                    <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>
                                        {t('serviceContractDelegation.table.serviceCompany')}
                                    </TableCell>
                                    <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>
                                        {t('serviceContractDelegation.table.executionDate')}
                                    </TableCell>
                                    <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>
                                        {t('serviceContractDelegation.table.startDate')}
                                    </TableCell>
                                    <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>
                                        {t('serviceContractDelegation.table.endDate')}
                                    </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>
                                        {t('serviceContractDelegation.table.actions')}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loadServiceContractDelegation ? (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center">
                                            <Loader />
                                        </TableCell>
                                    </TableRow>
                                ) : ServiceContractDelegation.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center">
                                            <Typography variant="subtitle1">
                                                {t('serviceContractDelegation.table.no_data')}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    ServiceContractDelegation.map((serviceContractDelegation) => (
                                        <TableRow key={serviceContractDelegation.id}>
                                            <TableCell align='center'>
                                                {serviceContractDelegation.delegationName}
                                            </TableCell>
                                            <TableCell align='center'>{serviceContractDelegation.name}</TableCell>
                                            <TableCell align='center'>
                                                {serviceContractDelegation.unionName}
                                            </TableCell>
                                            <TableCell align='center'>
                                                {serviceContractDelegation.serviceCompanyName}
                                            </TableCell>
                                            <TableCell align='center'>
                                                {serviceContractDelegation.executionDate ? new Intl.DateTimeFormat('es-ES').format(new Date(serviceContractDelegation.executionDate)) : ''}
                                            </TableCell>
                                            <TableCell align='center'>
                                                {serviceContractDelegation.startDate ? new Intl.DateTimeFormat('es-ES').format(new Date(serviceContractDelegation.startDate)) : ''}
                                            </TableCell>
                                            <TableCell align='center'>
                                                {serviceContractDelegation.endDate ? new Intl.DateTimeFormat('es-ES').format(new Date(serviceContractDelegation.endDate)) : ''}
                                            </TableCell>
                                            <TableCell align='center'>{serviceContractDelegation.deletedAt === null ? (
                                                <>
                                                    <Tooltip title={t('mostrar contacto')}>
                                                        <IconButton onClick={() => handleShowContact(serviceContractDelegation.id)}> <ContactPageIcon color="primary" /></IconButton>
                                                    </Tooltip>

                                                    <Tooltip title={t('serviceContractDelegation.table.actions.edit')}>
                                                        <IconButton component={RouterLink} to={PRIVATE_USER_FORM_CONTRACT_DELEGATION_SERVICE + "/" + serviceContractDelegation.id}> <Edit color="metal" /></IconButton>
                                                    </Tooltip>

                                                    {hasAdminPermission && (
                                                        <Tooltip title={t('serviceContractDelegation.table.actions.delete')}>
                                                            <IconButton onClick={() => { handleDelete(serviceContractDelegation.id) }}>
                                                                <Delete color="error" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    <Tooltip title={t('unionDelegationService.table.modal.restore.title')}> <IconButton onClick={() => handleRestore(serviceContractDelegation.id)}><Restore color="success" /></IconButton> </Tooltip>
                                                </>
                                            )}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Paper>

            {/* Paginacion */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}> <Pagination count={lastPage} page={currentPage} onChange={handlePageChange} /></Box>

            {/* Modal de confirmacion de eliminacion */}
            <Dialog open={openDeleteModal} onClose={() => setOpenDeleteModal(false)}>
                <DialogTitle>{t('serviceContractDelegation.table.modal.delete.title')}</DialogTitle>
                <DialogContent> <Typography variant="body1">{t('serviceContractDelegation.table.modal.delete.phrase')}</Typography></DialogContent>
                <DialogActions>
                    <Button color="secondary" onClick={() => setOpenDeleteModal(false)}>{t('serviceContractDelegation.table.modal.delete.button.cancel')}</Button>
                    <Button variant="contained" color="error" onClick={handleConfirmDelete}> {t('serviceContractDelegation.table.modal.delete.button.delete')} </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openContactDeleteModal} onClose={() => setOpenContactDeleteModal(false)}>
                <DialogTitle>{t('serviceContractDelegation.table.modal.delete.title')}</DialogTitle>
                <DialogContent><Typography variant="body1">{t('serviceContactDelegation.table.modal.delete.phrase')}</Typography> </DialogContent>
                <DialogActions>
                    <Button color="secondary" onClick={() => setOpenContactDeleteModal(false)}>{t('serviceContractDelegation.table.modal.delete.button.cancel')}</Button>
                    <Button variant="contained" color="error" onClick={handleConfirmContactDelete}>{t('serviceContractDelegation.table.modal.delete.button.delete')}</Button>
                </DialogActions>
            </Dialog>

            <Dialog maxWidth="lg" open={openContactModal} onClose={() => setOpenContactModal(false)}>
                <DialogTitle>{t('Contacto')}</DialogTitle>
                <DialogContent>
                    {loadingContacts ? (
                        <Typography>{t('Cargando contactos...')}</Typography>
                    ) : !contacts || contacts.length === 0 ? (
                        <Typography>{t('No hay contactos vinculados a este contrato.')}</Typography>
                    ) : (
                        <Table >
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#0492D4' }}>
                                    <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>{t('serviceContactDelegation.table.name')}</TableCell>
                                    <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>{t('serviceContactDelegation.table.apellido')}</TableCell>
                                    <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>{t('serviceContactDelegation.table.correoElectronico')}</TableCell>
                                    <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>{t('serviceContactDelegation.table.phoneNumber')}</TableCell>
                                    {hasAdminPermission && (
                                        <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>{t('serviceContactDelegation.table.actions')}</TableCell>
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {contacts.map(contact => (
                                    <TableRow key={contact.id}>
                                        <TableCell>{contact.name}</TableCell>
                                        <TableCell>{contact.apellido}</TableCell>
                                        <TableCell>{contact.correoElectronico}</TableCell>
                                        <TableCell>{contact.contactPhoneNumber}</TableCell>
                                        {hasAdminPermission && (
                                            <TableCell align='center'>{contact.deletedAt === null ? (
                                                <>

                                                    <Tooltip title={t('serviceContactDelegation.table.actions.edit')}>
                                                        <IconButton onClick={() => {
                                                            navigate(`${PRIVATE_USER_FORM_CONTACT_DELEGATION_SERVICE}/${contact.id}`, {
                                                                state: { contractId: contact.serviceContractDelegation?.id }
                                                            });
                                                            handleOpenModalCreate?.();
                                                        }} >
                                                        <Edit color="Primary" />
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip title={t('serviceContactDelegation.table.actions.delete')}>
                                                    <IconButton onClick={() => { handleContactDelete(contact.id) }}>
                                                        <Delete color="error" />
                                                    </IconButton>
                                                </Tooltip>
                                            </>
                                        ) : (
                                        <>
                                            <Tooltip title={t('serviceContactDelegation.table.modal.restore.title')}>
                                                <IconButton onClick={() => handleRestore(contact.id)}>
                                                    <Restore color="success" />
                                                </IconButton>
                                            </Tooltip>
                                        </>
                                            )}
                                    </TableCell>
                                )}
                            </TableRow>
                                ))}
                        </TableBody>
                        </Table>
                    )}
            </DialogContent>
            <DialogActions>
                {hasAdminPermission && (
                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        sx={{
                            backgroundColor: "#0492D4",
                            color: "white",
                            fontWeight: "bold",
                            borderRadius: "8px",
                            textTransform: "none",
                            "&:hover": { backgroundColor: "#037bb5" }
                        }}
                        onClick={() => {
                            navigate(`${PRIVATE_USER_FORM_CONTACT_DELEGATION_SERVICE}/new`, {
                                state: { contractId: id }
                            });
                            handleOpenModalCreate?.();
                        }}
                    >

                        {t('serviceContactDelegation.form.create')}

                    </Button>
                )}

                <Button variant="contained" color="error" sx={{
                    fontWeight: "bold",
                    borderRadius: "8px",
                    textTransform: "none",
                    "&:hover": { backgroundColor: "" }
                }}
                    onClick={() => setOpenContactModal(false)}>
                    {t('serviceContractDelegation.form.cancel')}
                </Button>
            </DialogActions>
        </Dialog >
            {/* Modal de restauracion */ }
            < Dialog open = { openRestoreModal } onClose = {() => setOpenRestoreModal(false)
}>
                <DialogTitle>{t('serviceContractDelegation.table.modal.restore.title')}</DialogTitle>
                <DialogContent>
                    <Typography variant="body1">{t('serviceContractDelegation.table.modal.restore.phrase')}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="secondary" onClick={() => setOpenRestoreModal(false)}>
                        {t('serviceContractDelegation.table.modal.restore.button.cancel')}
                    </Button>
                    <Button variant="contained" color="success" onClick={handleRestoreConfirm}>
                        {t('serviceContractDelegation.table.actions.restore')}
                    </Button>
                </DialogActions>
            </Dialog >

    {/* 🔹 Loader para evitar dobles peticiones */ }
    < DialogLoader open = { sendingApiRequest } />
        </>
    );
}

export default TableServiceContractDelegationView;